import '../../style/index.css';
import './index.css';

// style dependencies
import '../../empty/style/css';
import '../../spin/style/css';
import '../../pagination/style/css';
import '../../grid/style/css';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.3@ant-design-vue/es/list/style/css.js
// module id = YanI
// module chunks = 117